import { Component, Input } from '@angular/core';
import { ZtTableComponent } from '../zt-table/zt-table.component';
import {
    ZtTableHeaderInfo,
    ZtTableHeaderType,
} from '../zt-table/zt-table.model';
import { ZtHistoryTableItem } from './zt-history-table.model';

@Component({
    selector: 'zt-history-table',
    templateUrl: '../zt-table/zt-table.component.html',
    styleUrls: ['../zt-table/zt-table.component.scss'],
})
export class ZtHistoryTableComponent extends ZtTableComponent<ZtHistoryTableItem> {
    @Input() override data!: ZtHistoryTableItem[];

    override headerColsInfo: ZtTableHeaderInfo[] = [
        {
            headerName: 'Text',
            key: 'text',
            type: ZtTableHeaderType.STRING,
            widthPercentage: 20,
            sortable: true,
            filterable: true,
            shouldConcat: true,
        },
        {
            headerName: 'Language',
            key: 'language',
            type: ZtTableHeaderType.STRING_VARIANTS,
            widthPercentage: 13,
            sortable: true,
            filterable: true,
        },
        {
            headerName: 'Voice',
            key: 'voice',
            type: ZtTableHeaderType.STRING_VARIANTS,
            widthPercentage: 10,
            sortable: true,
            filterable: true,
        },
        {
            headerName: 'Pace',
            key: 'pace',
            type: ZtTableHeaderType.STRING,
            widthPercentage: 8,
            sortable: true,
            filterable: true,
        },
        {
            headerName: 'Pitch',
            key: 'pitch',
            type: ZtTableHeaderType.STRING,
            widthPercentage: 8,
            sortable: true,
            filterable: true,
        },
        {
            headerName: 'Requested At',
            key: 'requestedAt',
            type: ZtTableHeaderType.DATE,
            widthPercentage: 20,
            sortable: true,
            filterable: true,
        },
        {
            headerName: 'Sample',
            key: 'sample',
            type: ZtTableHeaderType.AUDIO,
            widthPercentage: 15,
        },
        {
            headerName: 'Actions',
            key: 'actions',
            type: ZtTableHeaderType.ACTIONS,
            widthPercentage: 10,
        },
    ];

    constructor() {
        super();
    }
}
